module.exports = __webpack_public_path__ + "static/media/nationality__image.c16bf322.png";